




























































































































import mixins from 'vue-typed-mixins'
import { BuildingValuationStepData } from '@/interfaces/valuation/ValuationData'
import {
  BuildingType,
  BuildingStatus,
} from '@/interfaces/valuation/types/BuildingValuationStep'
import valuationStepMixin from '@/mixins/valuation/valuationStep'

export default mixins(valuationStepMixin).extend({
  data(): { stepData: BuildingValuationStepData } {
    return {
      stepData: {
        buildingStatus: BuildingStatus.Finished,
        buildingType: undefined,
        buildingAge: undefined,
        buildingReconstruction: undefined,
      },
    }
  },
  computed: {
    showReconstruction(): boolean {
      if (
        this.stepData.buildingType &&
        this.stepData.buildingType !== this.BuildingType.New
      ) {
        return true
      }
      return false
    },
  },
  watch: {
    'stepData.buildingStatus': function(
      val: BuildingStatus,
      oldVal: BuildingStatus
    ) {
      if (val === this.BuildingStatus.Unfinished) {
        this.stepData.buildingType =
          this.propertyType === this.PropertyType.Flat
            ? this.BuildingType.New
            : undefined
        this.stepData.buildingAge = undefined
        this.stepData.buildingReconstruction = undefined
      }
    },
    'stepData.buildingType': function(val: BuildingType, oldVal: BuildingType) {
      if (val === this.BuildingType.New) {
        this.stepData.buildingAge = this.BuildingAge.Under15
      }
    },
  },
})
